export const CAROUSEL_PREV_BTN = 'carousel-prev-btn';
export const CAROUSEL_NEXT_BTN = 'carousel-next-btn';
